// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3OpNo","approved":"Status_approved__4-zO9","rejected":"Status_rejected__Zg6CJ","expired":"Status_expired__3ibOU","label":"Status_label__3wO5A"};